import { InjectionToken } from '@angular/core';

export type BooxRoutesToken = {
    home? : string[],
    sign_in? : string[],
    not_found? : string[]
};

export const BOOX_ROUTES = new InjectionToken<BooxRoutesToken>('(lib-boox) BOOX_ROUTES', {
    providedIn : 'root', factory: () => ({
        home : ['/'],
        sign_in : ['/','sign-in'],
        not_found : ['/','404'],
    })
});
